<script setup lang="ts">
import { tv } from 'tailwind-variants'

const props = defineProps<{ packet: Packet }>()

provide(keys.currentPacket, toRef(() => props.packet))

const variants = tv({
  variants: {
    theme: {
      'green-seagreen': '[--hero:var(--color-seagreen-40)] [--pitches:var(--color-seagreen-5)]',
      'dark-red-pink': '[--hero:var(--color-coral-60)] [--pitches:var(--color-coral-40)]',
      'blue-pink': '[--hero:var(--color-blue-60)] [--pitches:var(--color-blue-50)]',
      'green-red': '[--hero:var(--color-green-50)] [--pitches:var(--color-coral-10)]',
    },
  },
})

const cls = computed(() => variants({ theme: props.packet.theme }))
</script>

<template>
  <main
    id="main-content"
    :class="cls"
    class="bg-(--hero)"
  >
    <PacketHero />
    <PacketCards />
    <PacketProductsCta />
    <PacketQuote />
    <PacketPitches data-pitches class="bg-(--pitches)" />
    <PacketVideo data-video />
    <UiPacketsRelatedArticles />
    <PacketRelated />
  </main>
</template>

<style scoped>
[data-video] {
  --curtain: var(--hero);
}

[data-pitches] + [data-video] {
  --curtain: var(--pitches);
}
</style>
